import React, { type FC, useMemo, useState } from 'react'
import { type AxiosResponse } from 'axios'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IParamsTestSMS, type IResponseTestSMS } from 'widgets/TestSMS/types/types'
import { SendTestModalStore, TestSmsWithMergeField } from 'widgets/TestSMS/ui/TestSmsWithMergeField'
import {
  TestSMSDefault,
  type ITestSMSDefaultProps,
} from 'widgets/TestSMS/ui/TestSmsDefault/TestSMSDefault'

type ITestSMSProps = {
  disabled?: boolean
  params: IParamsTestSMS
  request: (params: IParamsTestSMS) => Promise<AxiosResponse<IResponseTestSMS>>
  onToggleShowTest?: (value: boolean) => void
  isTopError?: boolean
} & Omit<ITestSMSDefaultProps, 'sendTestModalStore'>

export const TestSMS: FC<ITestSMSProps> = observer((props) => {
  const { disabled, params } = props
  const entities = useEntitiesContext()
  const { mergeFieldStore } = entities
  const [sendTestModalStore] = useState(() => new SendTestModalStore(entities))
  const mergeFieldsTemplates = useMemo(
    () => params.message.match(/{.*?}/g)?.filter((field) => mergeFieldStore.isMergeField(field)),
    [params.message]
  )

  const withMergeWields = Boolean(mergeFieldsTemplates?.length)

  if (withMergeWields) {
    return (
      <TestSmsWithMergeField
        {...props}
        mergeFieldsTemplates={mergeFieldsTemplates || []}
        disabled={disabled}
        sendTestModalStore={sendTestModalStore}
      />
    )
  }
  return <TestSMSDefault sendTestModalStore={sendTestModalStore} {...props} />
})
